import type { ExecutiveResponse, Response } from '@/lib/apollo/query/getExecutive/query'

import type { TransformedData, TransformedExecutiveData } from './types'

export const toTransformedExecutive = (
  executive: ExecutiveResponse,
): TransformedExecutiveData => ({
  ...executive,
  skillLevel: executive.skillLevel ?? undefined,
})

export const toTransformedData = (response?: Response): TransformedData | undefined =>
  response === undefined ? undefined : toTransformedExecutive(response.getExecutive)
